import React from 'react';
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
} from 'reactstrap';
import stringTable from '../../config/stringTable';

import styles from './Offer.styles.module.scss';

const englishIsTheOnlyLanguageSupported = 'en';
const wordings = stringTable[englishIsTheOnlyLanguageSupported];

export default function OfferAccepted({ offer }) {
  const { errorType, status } = offer;
  if (errorType || status !== 'accepted') return null;
  return (
    <Card className={styles.card}>
      <CardBody>
        <CardTitle tag="h5">
          <div>
            { wordings['Offer Accepted!'] }
          </div>
        </CardTitle>
        <CardText>
          { wordings['Your personal offer code is:'] }
          <div className={styles['offer-code']}>XXYYZZ</div>
          { wordings['The above details have also just been emailed to you.'] }
        </CardText>
        <CardText>
          { wordings['It might take a few minutes for the email to arrive and your email provider may file it as '
          + 'spam or another category so be sure to check those other folders.'] }
        </CardText>
        <CardText>
          { wordings['You can take your code to the closest Wallace location where someone '
          + 'will help you complete the process.'] }
        </CardText>
      </CardBody>
    </Card>
  );
}
